import { render, staticRenderFns } from "./Picker.vue?vue&type=template&id=6ed4faea&scoped=true&"
import script from "./Picker.vue?vue&type=script&lang=js&"
export * from "./Picker.vue?vue&type=script&lang=js&"
import style0 from "./Picker.vue?vue&type=style&index=0&id=6ed4faea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed4faea",
  null
  
)

export default component.exports